import { Money } from "@hubrise/react-components"
import * as React from "react"

import Modal from "Catalog/Grid/shared/components/BulkUpdatePrices/Modal"
import { IVariant } from "shared/hubrise/models"

import { ItemType, RoundingOptions, BulkUpdatePricesRules } from "./types"

export type { RoundingOptions, BulkUpdatePricesRules }

type State = { isOpen: false } | { isOpen: true; targetVariant: IVariant | null }

export const useBulkUpdatePrices = (
  itemType: ItemType,
  bulkUpdatePrices: ((variant: IVariant | null, rules: BulkUpdatePricesRules) => void) | undefined,
) => {
  const [state, setState] = React.useState<State>({ isOpen: false })

  const open = React.useCallback(
    (variant: IVariant | null) => setState({ isOpen: true, targetVariant: variant }),
    [setState],
  )

  const close = () => setState({ isOpen: false })

  const modal =
    state.isOpen && bulkUpdatePrices ? (
      <Modal
        targetVariant={state.targetVariant}
        itemType={itemType}
        onSubmit={(rules) => bulkUpdatePrices(state.targetVariant, rules)}
        close={close}
      />
    ) : undefined

  return {
    bulkUpdatePricesModal: modal,
    openBulkUpdatePrices: open,
  }
}

export const calculateUpdatedPrice = (price: Money, rules: BulkUpdatePricesRules): Money => {
  const withMoney = (cents: number) => new Money(cents, price.currency)

  const priceWithPercentage = price.cents + (price.cents * rules.percentage) / 100
  switch (rules.rounding) {
    case "None":
      return withMoney(priceWithPercentage)
    case "0.05":
      return withMoney(Math.round(priceWithPercentage / 5) * 5)
    case "0.10":
      return withMoney(Math.round(priceWithPercentage / 10) * 10)
  }
}
